import { useState } from "react";
import { SectionTitle } from "../_shared/section-title";
import { PageShell, Stack } from "../_shared/page-shell";
import { Card } from "../_shared/card";
import { IconCheck } from "../_shared/icons";
import { children, type Child } from "../_data/mock";
import { useDemo } from "../_shared/demo.provider";

const accent = {
  orange: "text-[var(--child-1-primary)]",
  blue: "text-[var(--child-2-primary)]",
} as const;

const childRing = {
  orange:
    "ring-[var(--child-1-primary)] bg-[var(--child-1-light)] text-[var(--child-1-primary)]",
  blue: "ring-[var(--child-2-primary)] bg-[var(--child-2-light)] text-[var(--child-2-primary)]",
} as const;

export function ExercisesPage() {
  const { exercises, markExerciseDone } = useDemo();
  const [childId, setChildId] = useState<Child["id"]>(
    children[0]?.id ?? "jeanne",
  );
  const visibleExercises = exercises.filter((ex) => ex.childId === childId);

  return (
    <>
      <SectionTitle title="Exercices" />
      <PageShell>
        <Stack>
          <Card title="Pour qui ?">
            <ul className="flex flex-wrap gap-2 pt-1">
              {children.map((c) => {
                const selected = childId === c.id;
                return (
                  <li key={c.id}>
                    <button
                      type="button"
                      onClick={() => setChildId(c.id)}
                      className={`inline-flex h-10 items-center rounded-full px-4 text-[14px] font-semibold ring-1 transition ${selected ? childRing[c.color] : "bg-[var(--surface-1)] text-[var(--text-2)] ring-[var(--border-1)] hover:bg-[var(--surface-2)]"}`}
                    >
                      {c.firstName}
                    </button>
                  </li>
                );
              })}
            </ul>
          </Card>

          {visibleExercises.map((ex) => {
            const child = children.find((c) => c.id === ex.childId);
            if (!child) return null;
            return (
              <Card key={ex.id} title={child.firstName}>
                <p
                  className={`text-[13.5px] font-semibold ${accent[child.color]}`}
                >
                  {ex.label}
                </p>
                <div className="mt-3 flex items-center justify-between gap-3">
                  <span className="text-[12px] text-[var(--text-2)]">
                    Série en cours : {ex.streakDays} jours
                  </span>
                  {ex.doneToday ? (
                    <span className="inline-flex items-center gap-1.5 rounded-full bg-emerald-100 px-2.5 py-1 text-[11.5px] font-semibold text-emerald-700">
                      <IconCheck width={12} height={12} strokeWidth={2.5} />
                      Fait aujourd'hui
                    </span>
                  ) : (
                    <button
                      type="button"
                      onClick={() => markExerciseDone(ex.id)}
                      className="inline-flex h-9 items-center rounded-full bg-[var(--text-1)] px-3.5 text-[12px] font-semibold text-[var(--surface-1)] transition active:scale-95"
                    >
                      Marquer comme fait
                    </button>
                  )}
                </div>
              </Card>
            );
          })}
        </Stack>
      </PageShell>
    </>
  );
}
